var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pageRoot" }, [
    _vm.error
      ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
      : _vm.loading
      ? _c(
          "div",
          { staticClass: "loading" },
          [_c("ScaleLoader"), _vm._v(" Loading…")],
          1
        )
      : !_vm.mcpEnabled
      ? _c("div", [
          _c("div", { staticClass: "heading" }, [_vm._v("API Tokens")]),
          _vm._v(" "),
          _c("div", { staticClass: "bodySection" }, [
            _vm._v(
              "\n\t\t\tAPI tokens let AI agents use " +
                _vm._s(_vm.systemName) +
                " through its MCP (Model Context Protocol) endpoint. This feature is disabled. An administrator can enable it in Admin > Settings.\n\t\t"
            )
          ])
        ])
      : _c("div", [
          _c("div", { staticClass: "heading" }, [
            _vm._v("API Tokens for AI Agents")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bodySection" }, [
            _c("p", [
              _vm._v(
                "\n\t\t\t\tA token lets an AI agent (Claude Code, Codex, VS Code Copilot, Cursor, Gemini CLI, or any other MCP client) act as you through the MCP endpoint\n\t\t\t\t"
              ),
              _c("code", [_vm._v(_vm._s(_vm.mcpUrl))]),
              _vm._v(
                ". It can never do more than your account can, and only what its scopes allow.\n\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "warning" }, [
              _vm._v(
                "\n\t\t\t\tEvent content is sent to the AI provider. Some values are redacted by the server's policy, but treat everything in your events as visible to the agent.\n\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _vm.createdToken
            ? _c("div", { staticClass: "createdToken" }, [
                _c("div", { staticClass: "heading" }, [
                  _vm._v("New Token: " + _vm._s(_vm.createdTokenName))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bodySection" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "tokenRow" }, [
                      _c("input", {
                        staticClass: "tokenBox",
                        attrs: { type: "text", readonly: "" },
                        domProps: { value: _vm.createdToken },
                        on: {
                          focus: function($event) {
                            return $event.target.select()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "button", value: "Copy" },
                        on: {
                          click: function($event) {
                            return _vm.copy(_vm.createdToken)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("Ready-to-paste client configuration:")]),
                    _vm._v(" "),
                    _vm._l(_vm.snippets, function(s) {
                      return _c(
                        "div",
                        { key: s.name, staticClass: "snippet" },
                        [
                          _c("div", { staticClass: "snippetHeader" }, [
                            _c("span", { staticClass: "snippetName" }, [
                              _vm._v(_vm._s(s.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "snippetWhere" }, [
                              _vm._v(_vm._s(s.where))
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              attrs: { type: "button", value: "Copy" },
                              on: {
                                click: function($event) {
                                  return _vm.copy(s.text)
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("pre", [_vm._v(_vm._s(s.text))])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "button", value: "Done" },
                      on: {
                        click: function($event) {
                          _vm.createdToken = null
                        }
                      }
                    })
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "heading" }, [_vm._v("Create a Token")]),
          _vm._v(" "),
          _c("div", { staticClass: "bodySection createForm" }, [
            _c("div", { staticClass: "formRow" }, [
              _c("label", { attrs: { for: "tokenName" } }, [_vm._v("Name")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newName,
                    expression: "newName"
                  }
                ],
                staticClass: "nameBox",
                attrs: {
                  id: "tokenName",
                  type: "text",
                  maxlength: "100",
                  placeholder: "e.g. Claude Code on my laptop"
                },
                domProps: { value: _vm.newName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newName = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "formRow" }, [
              _c("span", { staticClass: "label" }, [_vm._v("Scopes")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "checkList" },
                _vm._l(_vm.scopes, function(s) {
                  return _c("label", { key: s, staticClass: "checkItem" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newScopes,
                          expression: "newScopes"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        value: s,
                        checked: Array.isArray(_vm.newScopes)
                          ? _vm._i(_vm.newScopes, s) > -1
                          : _vm.newScopes
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.newScopes,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = s,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.newScopes = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.newScopes = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.newScopes = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("b", [_vm._v(_vm._s(s))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "scopeDescription" }, [
                      _vm._v(_vm._s(_vm.scopeDescriptions[s]))
                    ])
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "formRow" }, [
              _c("span", { staticClass: "label" }, [_vm._v("Projects")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "checkList" },
                [
                  _c("label", { staticClass: "checkItem" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.allProjects,
                          expression: "allProjects"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.allProjects)
                          ? _vm._i(_vm.allProjects, null) > -1
                          : _vm.allProjects
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.allProjects,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.allProjects = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.allProjects = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.allProjects = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" All projects I can access")
                  ]),
                  _vm._v(" "),
                  !_vm.allProjects
                    ? _vm._l(_vm.projects, function(p) {
                        return _c(
                          "label",
                          { key: p, staticClass: "checkItem" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newProjects,
                                  expression: "newProjects"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: p,
                                checked: Array.isArray(_vm.newProjects)
                                  ? _vm._i(_vm.newProjects, p) > -1
                                  : _vm.newProjects
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.newProjects,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = p,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.newProjects = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.newProjects = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.newProjects = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" " + _vm._s(p) + "\n\t\t\t\t\t\t")
                          ]
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "formRow" }, [
              _c("label", { attrs: { for: "tokenExpiry" } }, [
                _vm._v("Expires")
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newExpiry,
                      expression: "newExpiry"
                    }
                  ],
                  attrs: { id: "tokenExpiry" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.newExpiry = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("Never")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "7" } }, [
                    _vm._v("In 7 days")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "30" } }, [
                    _vm._v("In 30 days")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "90" } }, [
                    _vm._v("In 90 days")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "365" } }, [
                    _vm._v("In 1 year")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "formRow" }, [
              _c("input", {
                attrs: {
                  type: "button",
                  value: "Create Token",
                  disabled: _vm.creating
                },
                on: { click: _vm.createToken }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "heading" }, [_vm._v("Your Tokens")]),
          _vm._v(" "),
          _c("div", { staticClass: "bodySection" }, [
            _vm.tokens.length === 0
              ? _c("div", [_vm._v("You have no tokens.")])
              : _c("table", { staticClass: "tokenTable" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.tokens, function(t) {
                      return _c(
                        "tr",
                        { key: t.apiTokenId, class: { inactive: !t.active } },
                        [
                          _c("td", [_vm._v(_vm._s(t.name))]),
                          _vm._v(" "),
                          _c("td", [
                            _c("code", [_vm._v(_vm._s(t.prefix) + "…")])
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(t.scopes.join(", ")))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(t.projects ? t.projects.join(", ") : "All")
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.dateStr(t.created)))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                t.lastUsed
                                  ? _vm.dateStr(t.lastUsed) +
                                      " from " +
                                      t.lastUsedIP
                                  : "Never"
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                t.expires ? _vm.dateStr(t.expires) : "Never"
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.statusStr(t)))]),
                          _vm._v(" "),
                          _c("td", [
                            !t.revoked
                              ? _c("input", {
                                  attrs: { type: "button", value: "Revoke" },
                                  on: {
                                    click: function($event) {
                                      return _vm.revoke(t)
                                    }
                                  }
                                })
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("b", [_vm._v("Copy this token now. It will not be shown again.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _c("th", [_vm._v("Token")]),
        _c("th", [_vm._v("Scopes")]),
        _c("th", [_vm._v("Projects")]),
        _c("th", [_vm._v("Created")]),
        _c("th", [_vm._v("Last Used")]),
        _c("th", [_vm._v("Expires")]),
        _c("th", [_vm._v("Status")]),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }